export const SET_APPROVE = 'SET_APPROVE';
export const SET_SIGNATURES = 'SET_SIGNATURES';
export const SET_NUMBER_OF_PAGES = 'SET_NUMBER_OF_PAGES';
